import cookieStorageHandler from './Storage/cookieStorageHandler';
import sessionStorageHandler from './Storage/sessionStorageHandler';
import { isInIframe } from './iframeDetector';
var axiosSetCookieInterceptor = function (axiosInstance, options, hooks) {
    var storage = isInIframe() ? sessionStorageHandler : cookieStorageHandler;
    axiosInstance.interceptors.request.use(function (config) {
        var jwt = storage.get(options.cookieName);
        if (jwt) {
            config.headers[options.requestHeaderName] = jwt;
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    axiosInstance.interceptors.response.use(function (response) {
        var sessionCookieValue = response.headers && response.headers[options.responseHeaderName];
        if (!sessionCookieValue) {
            return response;
        }
        var cookieOptions = {};
        if (!isInIframe()) {
            var expires = new Date(new Date().getTime() + parseFloat(options.cookieLifetime) * (1000 * 60 * 60 * 24));
            cookieOptions = {
                domain: options.cookieDomain,
                expires: expires,
                secure: !!window.location.protocol.match(/^https/)
            };
        }
        storage.set(options.cookieName, sessionCookieValue, cookieOptions);
        if (hooks && typeof hooks.onReceive === 'function') {
            hooks.onReceive(sessionCookieValue);
        }
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
};
export default axiosSetCookieInterceptor;
//# sourceMappingURL=axiosSetCookieInterceptor.js.map